var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBlackVoiceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 7.62891,
  r: 3.25,
  stroke: "black",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.7676 8.99549C15.7177 8.01622 15.7189 6.44125 14.7676 5.45996",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18 10.0004C19.6126 8.33839 19.6146 5.66542 18 4",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M1 19.1289V16.6289C1 14.9721 2.34315 13.6289 4 13.6289H13C14.6569 13.6289 16 14.9721 16 16.6289V19.1289",
  stroke: "black",
  strokeWidth: 1.5
})));
export default SvgBlackVoiceIcon;